var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_c('span'),_c('p',[_vm._v("管理员")])])])])
}]

export { render, staticRenderFns }